import React from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import MainChart from './MainChart';
import Invoices from './Invoices';
import { useReport } from '../../../Data/Reports';
import Section, { Sections } from '../../../Components/Containers/Section';
import { PageLoading } from '../../../Components/Loading';
import StatCards from '../../../Components/Formatting/StatCards';
import Money from '../../../Components/Formatting/Money';

const LegacyReports = () => {
    const {report} = useReport('/customers/report');

    return <>
        <TopBar left="/reports" title="Overview" />
        <Page>
            {report ? <Inner {...{report}} /> : <PageLoading />}
        </Page>
    </>
}

const Inner = ({report}) => {
    return <Sections>
        <MainChart />
        <Invoices invoices={report?.invoices ?? null} />
        <Section title="Customer balances">
            <StatCards cards={[
                {
                    title: <>Credit ({report?.balances?.positive?.count ?? 0})</>,
                    value: <Money pence={report?.balances?.positive?.sum ?? 0} colour hidePence />
                },
                {
                    title: <>Debit ({report?.balances?.negative?.count ?? 0})</>,
                    value: <Money pence={report?.balances?.negative?.sum ?? 0} colour hidePence />
                },
            ]} />
        </Section>
        <Section title="Recurring value" subtitle={<>{report?.statuses?.active?.count} Customers</>}>
            <StatCards cards={[
                {
                    title: "Monthly",
                    value: <Money pence={report?.value?.monthlyValue ?? 0} hidePence />
                },
                {
                    title: "Annual",
                    value: <Money pence={report?.value?.annualValue ?? 0} hidePence />
                },
            ]} />
        </Section>
    </Sections>
}

export default LegacyReports;
